(()=>{
  const context=document.querySelector('[data-imperial-discovery-context]');
  if(!context)return;
  const ctx=context.dataset.imperialDiscoveryContext||'';
  if(!['collection-watches','collection-rolex'].includes(ctx))return;

  const norm=v=>(v||'').replace(/\s+/g,' ').trim();
  const productUrl=link=>{
    try{const url=new URL(link.getAttribute('href'),location.origin);return `${url.origin}${url.pathname}`;}
    catch(e){return'';}
  };
  const productHandle=link=>{
    try{
      const url=new URL(link.getAttribute('href'),location.origin);
      const m=url.pathname.match(/\/products\/([^/]+)/);
      return m?decodeURIComponent(m[1]):'';
    }catch(e){return'';}
  };
  const stateMap=()=>{
    try{
      const payload=JSON.parse(document.querySelector('[data-imperial-sellability-items]')?.textContent||'{}');
      return new Map((payload.items||[]).map(item=>[item.handle,item.state]));
    }catch(e){return new Map();}
  };
  const cards=()=>[...new Set(document.querySelectorAll('#product-grid .grid__item,#product-grid .product-card,.wbproduct-container .product-card'))];

  function syncCard(card,map){
    const existing=card.querySelector('.imperial-watch-source-another-wrap');
    const link=card.querySelector('.product-card__title a[href*="/products/"],.card__heading a[href*="/products/"],a.full-unstyled-link[href*="/products/"],a[href*="/products/"]');
    const handle=link?productHandle(link):'';
    let state=card.dataset.imperialSellability||map.get(handle)||'';

    if(!state){
      const badge=card.querySelector('button.soldout_product_badge,.soldout_product_badge');
      const badgeText=norm(badge?.textContent).toLowerCase();
      if(badge&&/sold|unavailable|out of stock/.test(badgeText))state='unavailable';
    }

    if(state!=='unavailable'){
      if(existing)existing.remove();
      return;
    }
    if(existing||!link)return;

    const info=card.querySelector('.product-card__info,.card__information');
    if(!info)return;

    const title=norm(card.querySelector('.product-card__title,.card__heading')?.textContent)||norm(link.textContent)||norm(link.getAttribute('aria-label'));
    const url=productUrl(link);
    if(!title||!url)return;

    const message=`Hello Imperial Time, this ${title} has sold. Please help me source the same model or a comparable watch - ${url}`;
    const wrap=document.createElement('div');
    wrap.className='imperial-watch-source-another-wrap';

    const action=document.createElement('a');
    action.className='button button--secondary imperial-watch-source-another';
    action.href=`https://wa.me/447538174795?text=${encodeURIComponent(message)}`;
    action.target='_blank';
    action.rel='noopener';
    action.textContent='Source Another';
    action.setAttribute('aria-label',`Source another ${title}`);
    action.dataset.watchAction='source-model';
    action.dataset.imperialSourceAnother='1';

    wrap.appendChild(action);
    info.appendChild(wrap);
  }

  function run(){
    const map=stateMap();
    cards().forEach(card=>syncCard(card,map));
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();

  let queued=false;
  const observer=new MutationObserver(()=>{
    if(queued)return;
    queued=true;
    requestAnimationFrame(()=>{
      queued=false;
      run();
    });
  });
  observer.observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['data-imperial-sellability']});
  document.addEventListener('shopify:section:load',run);
})();
